import { PRODUCT_TYPE } from "config/constants";

export const isMaterial = (productType) => productType === PRODUCT_TYPE.MATERIAL;

export const convertManufacturer = (data) => data?.map((item) => ({ value: item?.id, label: item.name }));

export const convertWarehouse = (data) => data?.map((item) => ({ value: item?.id, label: item.name }));
